import React from 'react';
import DataTable, { createTheme } from 'react-data-table-component';

// Custom Theme
createTheme('custom', {
    text: {
        primary: '#4A5568', // Dark gray for text
        secondary: '#718096', // Lighter gray
    },
    background: {
        default: '#f9fafb', // Light gray background
    },
    context: {
        background: '#e2e8f0', // Selection highlight background
        text: '#000',
    },
    divider: {
        default: '#cbd5e0', // Table border color
    },
    button: {
        default: '#4A5568', // Button text
        hover: 'rgba(90, 103, 116, 0.9)', // Hover state
        focus: 'rgba(90, 103, 116, 0.9)', // Focus state
    },
    sortFocus: {
        default: '#a0aec0', // Column header sort icon focus
    },
});

// Table Data
const data = [
    { id: 1, name: 'Airi Satou', position: 'Accountant', office: 'Tokyo', age: 33, startDate: '11/28/2008' },
    { id: 2, name: 'Angelica Ramos', position: 'CEO', office: 'London', age: 47, startDate: '10/09/2009' },
    { id: 3, name: 'Ashton Cox', position: 'Junior Technical Author', office: 'San Francisco', age: 66, startDate: '01/12/2009' },
];

const columns = [
    {
        name: 'Name',
        selector: row => row.name,
        sortable: true,
    },
    {
        name: 'Position',
        selector: row => row.position,
        sortable: true,
    },
    {
        name: 'Office',
        selector: row => row.office,
        sortable: true,
    },
    {
        name: 'Age',
        selector: row => row.age,
        sortable: true,
    },
    {
        name: 'Start Date',
        selector: row => row.startDate,
        sortable: true,
    },
];

const StyledTable = () => {
    return (
        <div style={{ padding: '20px', borderRadius: '8px', backgroundColor: '#ffffff', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
            <DataTable
                title="Applicants Table"
                columns={columns}
                data={data}
                pagination
                responsive
                theme="custom"
                highlightOnHover
            />
        </div>
    );
};

export default StyledTable;
